<template>
    <!-- `segmented: true` on a two-option field: both choices visible at once,
         centred under the label, as in the report designs. -->
    <div    v-if="segmented"
            class="flex flex-col items-center gap-2 py-3">
        <div class="flex items-center gap-2 text-sm font-semibold text-gray-900">
            {{ field.label }}
            <info-tip v-if="field.description"
                      :text="field.description"
            ></info-tip>
        </div>

        <segmented-toggle   :model-value="modelValue"
                            :on-value="optionValues[0]"
                            :off-value="optionValues[1]"
                            :on-label="options[optionValues[0]]"
                            :off-label="options[optionValues[1]]"
                            :aria-label="field.label"
                            @update:model-value="$emit('update:modelValue', $event)"
        ></segmented-toggle>

        <p  v-if="error"
            class="m-0 text-xs text-red-500">
            {{ error }}
        </p>
    </div>

    <report-field-row   v-else
                        :field-id="field.key"
                        :label="field.label"
                        :description="field.description"
                        :error="error"
    >
        <select2    :id="field.key"
                    :options="options"
                    :value="modelValue"
                    :multiple="field.multiple === true"
                    :allow-clear="field.allowClear === true"
                    :close-on-select="true"
                    :disable-search="hideSearch"
                    @update:value="$emit('update:modelValue', $event)"
        ></select2>
    </report-field-row>
</template>

<script>
import ReportFieldRow from "../ReportFieldRow.vue"
import Select2 from "@/components/elements/select2.vue"
import SegmentedToggle from "@/components/elements/SegmentedToggle.vue"
import InfoTip from "@/components/elements/InfoTip.vue"

export default {
    name: "ReportSelectField",
    components: {ReportFieldRow, Select2, SegmentedToggle, InfoTip},
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            type: [String, Number, Array, Object],
            default: null,
        },
        field: {
            type: Object,
            required: true,
        },
        // Resolved by the panel: `field.options` may be a plain pluck object or
        // a function of the current settings/context.
        options: {
            type: Object,
            default: () => ({}),
        },
        error: {
            type: String,
            default: null,
        },
    },
    computed: {
        optionValues() {
            return Object.keys(this.options ?? {})
        },
        segmented() {
            return this.field.segmented === true && this.field.multiple !== true && this.optionValues.length === 2
        },
        /**
         * A search box is noise on a short list. Hidden automatically under ten
         * options, or forced either way with `searchable` on the schema field.
         */
        hideSearch() {
            if (typeof this.field.searchable === 'boolean') {
                return ! this.field.searchable
            }

            return Object.keys(this.options ?? {}).length < 10
        },
    },
}
</script>
